import gql from 'graphql-tag';
import { scheduledSessionParticipantEntryFieldsFragment } from '../fragments';

export const automaticallyAssignScheduledSessionOrderMutation = gql`
  mutation AutomaticallyAssignScheduledSessionOrder(
    $orderingType: ScheduledSessionAutomaticOrderingType!
    $scheduledSessionId: ID!
  ) {
    automaticallyAssignScheduledSessionOrder(
      orderingType: $orderingType
      scheduledSessionId: $scheduledSessionId
    ) {
      ...AdminScheduledSessionParticipantEntryFields
    }
  }

  ${scheduledSessionParticipantEntryFieldsFragment}
`;
